import campaignsListRedux from '../../views/list/redux/slice'
import campaignDetailRedux from '../../modals/detail/redux/slice'
//export redux objects
export default {
	campaignsListRedux,
	campaignDetailRedux
};
